'use client';

import React from 'react';
import type { IconProps } from '@/types/types';

export const IconName = {
  ChevronDown: "chevron-down",
  ChevronUp: "chevron-up",
  Check: "check",
  X: 'x',
  Star: 'star',
  Email: 'email',
  Phone: 'phone',
  // NAVBAR ICONS
  PandaHubLogo: 'pandahub-logo',
  PandaHubLogoInverted: 'pandahub-logo-inverted',
  NavbarCar: 'car-24',
  NavbarSeat: 'seat-24',
  NavbarWheel: 'wheel-24',
  NavbarWheelExterior: 'wheel-24exterior',
  NavbarContact: 'contact-24',
  NavbarPanda: 'panda-24',
  NavbarBlog: 'blog-24',
  NavbarAbout: 'aboutus-24',
  NavbarFAQ: 'faq-24',
  NavbarProfile: 'profile-24',

  // Social Icons
  LinkedIn: 'linkedin-24',

  // Misc
  Trophy: 'trophy-24',
  Magazine: 'magazine-24',
  BlackStar: 'black-star-19',
  Lightbulb: 'lightbulb-24',
  Location: 'location-16',

  Home: 'home-24',
  CarDrop: 'car-drop-24',
  Wheel24: 'wheel-24',
  GreenCheckmark: 'green-checkmark',
  RedCross: 'red-cross',
  Copy: 'copy-20',
}


const defaultSize = 20;
function getDimensions(size: number | undefined, width?: number, height?: number) {
  const finalWidth = width ?? size ?? defaultSize;
  const finalHeight = height ?? size ?? defaultSize;
  return { finalWidth, finalHeight };
}
interface PandaIconsProps extends IconProps {
  name: keyof typeof IconName;
  size?: number;
  strokeWidth?: number;
  ariaLabel?: string;
  mode?: 'auto' | 'inline' | 'external';
}
export const PandaIcons = ({
  name,
  size,
  width,
  height,
  color = 'currentColor',
  className,
  ariaLabel,
  'aria-hidden': ariaHidden,
}: PandaIconsProps) => {
  const { finalWidth, finalHeight } = getDimensions(size, width, height);
  const accessibilityProps = ariaLabel
    ? { role: 'img' as const, 'aria-label': ariaLabel }
    : { 'aria-hidden': ariaHidden ?? true };

  const icon = IconName[name];
  const iconName = icon.toLowerCase().replace(/[^a-z0-9-]/g, '');

  const wrapperStyle: React.CSSProperties = {
    width: finalWidth,
    height: finalHeight,
    ...(color !== 'currentColor' ? { color } : {}),
  };

  return (
    <span className={className} style={wrapperStyle} {...accessibilityProps}>
      <span
        aria-hidden
        className="block w-full h-full"
        style={{
          backgroundColor: 'currentColor',
          maskImage: `url(/icons/${iconName}.svg)`,
          maskSize: 'contain',
          maskRepeat: 'no-repeat',
          maskPosition: 'center',
          WebkitMaskImage: `url(/icons/${iconName}.svg)`,
          WebkitMaskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
        }}
      />
    </span>
  );
};